import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/pesquisa-inteligente';

export default {
    realizarPesquisaHome(filtro, pesquisaExata = false) {
        let url = baseUrl + `?filtro=${filtro}`;

        if (pesquisaExata !== null && pesquisaExata !== undefined && pesquisaExata !== false) {
            url += `&pesquisaExata=${pesquisaExata}`;
        }

        return http.get({
            url: url,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisa')
        });
    },

    realizarPesquisaTerritorios(filtro) {
        return http.get({
            url: baseUrl + `/territorios?filtro=${filtro}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoPesquisaEmTerritorios')
        });
    }
};
